import { createAction, props } from '@ngrx/store';
import { PaginationWrapper } from '../../../shared/models/pagination-wrapper';
import { FuelCard } from '../../../fuel-card/models/fuel-card';
import { FileMetaData } from '../../../fuel-card/models/file-meta-data';
import { AcceptParsedData } from '../../../fuel-card/interfaces/accept-parsed-data';
import { SaveParsedDataResponse } from '../../../fuel-card/models/save-parsed-data-response';
import { FuelingMerge } from '../../../fuel-card/models/fueling-merge';
import { FuelingMergeBase } from '../../../fuel-card/models/fueling-merge-base';
import { UpdateFuelingResponse } from '../../../fuel-card/interfaces/update-fueling-response';

export const getFuelCards = createAction('[FuelCard] Get Fuel Cards', props<{currentPage: number, pageSize: number}>());
export const getFuelCardsSuccess = createAction('[FuelCard] Get Fuel Cards Success', props<{data: PaginationWrapper<FuelCard>}>());
export const getFuelCardsFailure = createAction('[FuelCard] Get Fuel Cards Failure', props<{error: any}>());
export const getFilesMetaData = createAction('[FuelCard] Get Files Meta Data');
export const getFilesMetaDataSuccess = createAction('[FuelCard] Get Files Meta Data Success', props<{data: FileMetaData[]}>());
export const getFilesMetaDataFailure = createAction('[FuelCard] Get Files Meta Data Failure', props<{error: any}>());
export const parseFuelCardFile = createAction('[FuelCard] Parse Fuel Card File', props<{form: FormData}>());
export const parseFuelCardFileSuccess = createAction('[FuelCard] Parse Fuel Card File Success', props<{data: any}>());
export const parseFuelCardFileFailure = createAction('[FuelCard] Parse Fuel Card File Failure', props<{error: any}>());
export const saveParsedFuelCardFile = createAction('[FuelCard] Save Parsed Fuel Card File', props<{data: AcceptParsedData}>());
export const saveParsedFuelCardFileSuccess = createAction('[FuelCard] Save Parsed Fuel Card File Success', props<{data: SaveParsedDataResponse}>());
export const saveParsedFuelCardFileFailure = createAction('[FuelCard] Save Parsed Fuel Card File Failure', props<{error: any}>());
export const getFuelingMergeData = createAction('[FuelCard] Get Fueling Merged Data', props<{unitIds: number[], from: string, to: string}>());
export const getFuelingMergeDataSuccess = createAction('[FuelCard] Get Fueling Merged Data Success', props<{data: FuelingMerge[]}>());
export const getFuelingMergeDataFailure = createAction('[FuelCard] Get Fueling Merged Data Failure', props<{error: any}>());
export const updateFuelingMerge = createAction('[FuelCard] Update Fueling Merge', props<{fuelingMergeId: number, data: FuelingMergeBase}>());
export const updateFuelingMergeSuccess = createAction('[FuelCard] Update Fueling Merge Success', props<{data: UpdateFuelingResponse}>());
export const updateFuelingMergeFailure = createAction('[FuelCard] Update Fueling Merge Failure', props<{error: any}>());
export const getFuelingMergeByIds = createAction('[FuelCard] Get Fueling Merge By Ids', props<{fuelingMergeIds: number[]}>());
export const getFuelingMergeByIdsSuccess = createAction('[FuelCard] Get Fueling Merge By Ids Success', props<{data: FuelingMerge[]}>());
export const getFuelingMergeByIdsFailure = createAction('[FuelCard] Get Fueling Merge By Ids Failure', props<{error: any}>());
export const approveFuelingMergeByIds = createAction('[FuelCard] Approve Fueling Merge By Ids', props<{fuelingMergeIds: number[]}>());
export const approveFuelingMergeByIdsSuccess = createAction('[FuelCard] Approve Fueling Merge By Ids Success', props<{data: number[]}>());
export const approveFuelingMergeByIdsFailure = createAction('[FuelCard] Approve Fueling Merge By Ids Failure', props<{error: any}>());
export const markAsRealFuelingByIds = createAction('[FuelCard] Mark As Real Fueling By Ids', props<{fuelingMergeIds: number[]}>());
export const markAsRealFuelingByIdsSuccess = createAction('[FuelCard] Mark As Real Fueling By Ids Success', props<{data: number[]}>());
export const markAsRealFuelingByIdsFailure = createAction('[FuelCard] Mark As Real Fueling By Ids Failure', props<{error: any}>());
export const markAsNotRealFuelingByIds = createAction('[FuelCard] Mark As Not Real Fueling By Ids', props<{fuelingMergeIds: number[]}>());
export const markAsNotRealFuelingByIdsSuccess = createAction('[FuelCard] Mark As Not Real Fueling By Ids Success', props<{data: number[]}>());
export const markAsNotRealFuelingByIdsFailure = createAction('[FuelCard] Mark As Not Real Fueling By Ids Failure', props<{error: any}>());
export const mergeFuelingMerge = createAction('[FuelCard] Merge Fueling Merge', props<{data: FuelingMergeBase, id1, id2}>());
export const mergeFuelingMergeSuccess = createAction('[FuelCard] Merge Fueling Merge Success', props<{data: UpdateFuelingResponse}>());
export const mergeFuelingMergeFailure = createAction('[FuelCard] Merge Fueling Merge Failure', props<{error: any}>());
export const unMergeFuelingMerge = createAction('[FuelCard] Unmerge Fueling Merge', props<{fuelingMergeId, data: FuelingMergeBase}>());
export const unMergeFuelingMergeSuccess = createAction('[FuelCard] Unmerge Fueling Merge Success', props<{fuelingMergeId, data: UpdateFuelingResponse}>());
export const unMergeFuelingMergeFailure = createAction('[FuelCard] Unmerge Fueling Merge Failure', props<{error: any}>());
export const deleteFuelingMergeById = createAction('[FuelCard] Delete Fueling Merge By Id', props<{fuelingMergeId}>());
export const deleteFuelingMergeByIdSuccess = createAction('[FuelCard] Delete Fueling Merge By Id Success', props<{fuelingMergeId}>());
export const deleteFuelingMergeByIdFailure = createAction('[FuelCard] Delete Fueling Merge By Id Failure', props<{error: any}>());
export const addFuelingMerge = createAction('[FuelCard] Add Fueling Merge', props<{data: FuelingMerge}>());
export const addFuelingMergeSuccess = createAction('[FuelCard] Add Fueling Merge Success', props<{data: UpdateFuelingResponse}>());
export const addFuelingMergeFailure = createAction('[FuelCard] Add Fueling Merge Failure', props<{error: any}>());

export type FuelCardsActionsUnion = ReturnType<
  typeof getFuelCards |
  typeof getFuelCardsSuccess |
  typeof getFuelCardsFailure |
  typeof getFilesMetaData |
  typeof getFilesMetaDataSuccess |
  typeof getFilesMetaDataFailure |
  typeof parseFuelCardFile |
  typeof parseFuelCardFileSuccess |
  typeof parseFuelCardFileFailure |
  typeof saveParsedFuelCardFile |
  typeof saveParsedFuelCardFileSuccess |
  typeof saveParsedFuelCardFileFailure |
  typeof getFuelingMergeData |
  typeof getFuelingMergeDataSuccess |
  typeof getFuelingMergeDataFailure |
  typeof updateFuelingMerge |
  typeof updateFuelingMergeSuccess |
  typeof updateFuelingMergeFailure |
  typeof getFuelingMergeByIds |
  typeof getFuelingMergeByIdsSuccess |
  typeof getFuelingMergeByIdsFailure |
  typeof approveFuelingMergeByIds |
  typeof approveFuelingMergeByIdsSuccess |
  typeof approveFuelingMergeByIdsFailure |
  typeof mergeFuelingMerge |
  typeof mergeFuelingMergeSuccess |
  typeof mergeFuelingMergeFailure |
  typeof unMergeFuelingMerge |
  typeof unMergeFuelingMergeSuccess |
  typeof unMergeFuelingMergeFailure |
  typeof deleteFuelingMergeById |
  typeof deleteFuelingMergeByIdSuccess |
  typeof deleteFuelingMergeByIdFailure |
  typeof addFuelingMerge |
  typeof addFuelingMergeSuccess |
  typeof addFuelingMergeFailure |
  typeof markAsRealFuelingByIds |
  typeof markAsRealFuelingByIdsSuccess |
  typeof markAsRealFuelingByIdsFailure |
  typeof markAsNotRealFuelingByIds |
  typeof markAsNotRealFuelingByIdsSuccess |
  typeof markAsNotRealFuelingByIdsFailure
  >;
